import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";

const LanguageSelector = () => {
  const navigate = useNavigate();
  const { language, getAlternatePath } = useLanguage();

  const handleLanguageSwitch = () => {
    const alternatePath = getAlternatePath();
    navigate(alternatePath);
  };

  return (
    <button
      onClick={handleLanguageSwitch}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 text-foreground/80 hover:text-foreground hover:bg-muted/50 border border-border/50 hover:border-border"
      aria-label={language === "it" ? "Switch to English" : "Passa all'italiano"}
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase">{language === "it" ? "EN" : "IT"}</span>
    </button>
  );
};

export default LanguageSelector;
